// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 1H20V23H4V1ZM10.9996 17.0002V19.0041H13.0035V17.0002H10.9996ZM15.9733 13.8278L12.0003 5.88184L8.02734 13.8278L12.0003 12.5862L15.9733 13.8278Z"}}]};

const MobileNavigationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-navigation-filled',
    ref,
    icon: element,
  },
));

MobileNavigationFilledIcon.displayName = 'MobileNavigationFilledIcon';

export default MobileNavigationFilledIcon;
